import { type CalendarValues } from '../types';

interface FindDateToMergeInterface {
    mergedCalendarValues: CalendarValues[],
    remainingCalendarValues: CalendarValues[]
}

interface FindDateToMergeReturnValues {
    dateToMerge?: CalendarValues;
    dateToMergeInto?: CalendarValues;
    dateToMergeIntoIndex: number;
}

const hasMatchingStartAndEndTimes = (a: CalendarValues, b: CalendarValues): boolean => a.startTime === b.startTime && a.endTime === b.endTime;

const hasValidMatchingClassSessionGroupUuid = (a: CalendarValues, b: CalendarValues): boolean => a.classSessionGroupUuid === b.classSessionGroupUuid || a.classSessionGroupUuid === undefined || b.classSessionGroupUuid === undefined;

export const findDateToMerge = ({ mergedCalendarValues, remainingCalendarValues }: FindDateToMergeInterface): FindDateToMergeReturnValues => {
    const firstRemainingCalendarValues = remainingCalendarValues[0];

    // if we wanted to divide dates up whenever there's a gap in the schedule we could add in a datesAreConsecutive function here
    const callback = (merged) => hasMatchingStartAndEndTimes(merged, firstRemainingCalendarValues) && hasValidMatchingClassSessionGroupUuid(merged, firstRemainingCalendarValues);

    const dateToMergeInto = mergedCalendarValues.find(callback);
    const dateToMergeIntoIndex = mergedCalendarValues.findIndex(callback);

    return {
        dateToMerge: firstRemainingCalendarValues,
        dateToMergeInto,
        dateToMergeIntoIndex
    };
};
